/* eslint-disable @typescript-eslint/no-unused-vars */
import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useStore from '@/stores/useStore';

import { Header, Footer } from '@/components/containers';
import { LandingPage } from '@/pages';
import './App.scss';

function App() {
    const getDetails = useRef(useStore((state) => state.getDetails));

    const { t, i18n } = useTranslation();

    let currentLang = '';

    useEffect(() => {
        let l =
            i18n.language.indexOf('-') >= 0
                ? i18n.language.split('-')[0]
                : i18n.language;
        if (currentLang == l) return;
        if (!currentLang && l) {
            currentLang = l;
        }
        getDetails.current?.(currentLang);
    }, [i18n.language]);

    return (
        <>
            <Header ariaLabel={'Banner'} alt={"Company's banner"} />

            <main aria-label={'Main Content'}>
                <LandingPage translation={t} />
            </main>
        </>
    );
}

export default App;
